import React from "react";
import "./header.css"; // Import the CSS file for styling
import logo from "../../assets/wjcwadmin-logo.png";


const Header = () => {
  return (
    <div className="header">
      <img src={logo} alt="Logo" className="logo" />
    </div>
  );
};

export default Header;
